
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

export const Hero = () => {
  const navigate = useNavigate();

  return (
    <div className="py-24 text-center">
      <div className="container max-w-4xl mx-auto px-4">
        <h1 className="text-4xl md:text-6xl font-semibold mb-6 leading-tight">
          Practice IELTS Writing <br /> Like It's the Real Thing
        </h1>
        <p className="text-xl text-stone-500 mb-6 max-w-3xl mx-auto">
          Hey there, IELTS candidate! 👋 Want to know exactly how you're doing on the writing test? We've built something special for you.
        </p>
        <Button
          size="lg"
          className="font-semibold px-4 py-3 text-md rounded-lg bg-orange-500 hover:bg-orange-500/90 text-white shadow-[inset_0px_1px_0px_0px_#FFFFFF66,0px_0px_0px_1px_#C2410CCC]"
          onClick={() => navigate("/auth")}
        >
          Start Practicing Now
        </Button>

        <div className="mt-20">
          <img
            src="/images/hero.webp"
            alt="IELTS Writing Interface"
            className="rounded-lg block dark:hidden"
            decoding="sync"
            width={864}
            height={593}
          />
          <img
            src="/images/hero-dark.webp"
            alt="IELTS Writing Interface"
            className="rounded-lg hidden dark:block"
            decoding="sync"
            width={864}
            height={593}
          />
        </div>
      </div>
    </div>
  );
};
